var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127.199,
    height: 125.449,
    viewBox: "0 0 127.199 125.449",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mono_logo",
    "data-name": "mono logo",
    d: "M160.35,240.594a60.655,60.655,0,0,1,7.428-26.3,63.931,63.931,0,0,1,76.491-31.464c20.53,6.5,35.477,22.006,41.06,42.536a61.714,61.714,0,0,1,2.076,18.961c-.969,20.207-12.226,38.891-30.034,50.01-20.438,14.025-48.026,14.532-68.6,1.338a61.585,61.585,0,0,1-28.419-55.084Zm118.7,5.767a60.32,60.32,0,0,0-63.527-62.143,60.444,60.444,0,0,0-30.495,11.9,59.41,59.41,0,0,0-21.591,31.048,55.565,55.565,0,0,0-1.2,9.181A57.407,57.407,0,0,0,175.3,275.61a60.763,60.763,0,0,0,50.979,22.929c18.546-.969,34.693-10.288,44.335-25.6A53.806,53.806,0,0,0,279.054,246.361ZM233.473,230.03c3.737-2.076,7.1-5.905,7.1-10.657,0-7.151-7.289-12.456-13.794-12.456H213.266v29.849a20.871,20.871,0,0,0-15.732,20.253c0,10.38,8.858,21.13,23.713,21.13,17.116,0,29.065-12.779,29.065-24.221C250.266,241.379,240.809,231.967,233.473,230.03Zm-7.335-.369h-7.289V209.085h7.289c5.305,0,8.858,4.152,8.858,10.288C234.95,225.139,231.074,229.66,226.138,229.66ZM221.2,275.933c-8.766,0-21.13-5.859-21.13-18.915,0-8.12,5.167-14.44,13.194-16.193v18.361h5.582V240.318c8.074.507,13.01,7.059,13.01,10.565v.508h2.168v-.508c.046-5.721-5.352-14.117-15.224-14.671v-4.383h11.211c5.813,0,14.625,8.812,14.625,22.052C244.684,268.367,232.874,275.933,221.2,275.933Z",
    transform: "translate(-160.279 -179.78)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLogo);
export default __webpack_public_path__ + "static/media/navLogo.779c1cf1096b256e4eca4b68bd844d86.svg";
export { ForwardRef as ReactComponent };